import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Component({
  selector: 'app-tmpe-common-login',
  templateUrl: './tmpe-common-login.component.html',
  styleUrls: ['./tmpe-common-login.component.css']
})
export class TmpeCommonLoginComponent implements OnInit {
  form: FormGroup;
  public role: any;
  public urn: any;
  public entityType: any;
  //public user: any;
  public userName: any;
  public readonly: boolean = false;
  public OTP_clicked: boolean = false;
  public showGenerateOTP: boolean = false;
  login1: any;
  homeRole: boolean = false;
  mobilenumber: any;
  URNorEntityID: any
  errorUser: boolean = false;
  errorOtp: boolean = false;
  errorReg: boolean = false;
  modifyUrl: boolean = false;
  ui2Url: boolean = false;
  EntityId: any;
  Entity_Name: any;
  Entity_Ref_No: any;
  Entity_User_Name: any;
  Entity_Org: any;
  E_Org_Name: any;
  Entity_EmailID: any;
  mob: any;
  roleSelected: any;
  hide = true;
  commonLoginForm: FormGroup;
  submitted: boolean = false;
  signFlag: boolean = true;
  public loginFlag = false;
  hideMobileNum: any;
  MobileNumber: any;
  errorRefFlag: any;
  errorRefMsg: any;
  errorOtpexpired: boolean;
  entityStatus: any;
  Kyc_Status: any;
  blacklisted: any;
  InactiveEntity: boolean;
  blacklistedEntity: boolean;
  entityExpiry: any;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private db: $DBManagerService,
    private ls: APILoginService,
    private es: APIEntityService,
    private _route: ActivatedRoute,
    private $modal: $ModalManagerService,
    private evt: $BroadcastManagerService) {
    this._route.params.subscribe((params) => {
      //this.roleSelected = params['role'];
      this.Entity_Ref_No = ""

    })
  }

  ngOnInit() {
    this.commonLoginForm = this.formBuilder.group({
      ID: ['', [Validators.required]],
      password: ['', [Validators.required]],
      otp: ['', []],
      phoneNumber: ['', []],
    });

    // this.db.clearDB();
    // window.onhashchange=function() {
    //   localStorage.removeItem('currentUser'); 
    // }
    // if(performance.navigation.type == 1){
    //   sessionStorage.clear();
    // }

  }
  downloadRegprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/DLT_Registration_Process.pdf';
    link.download = 'DLT Registration Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadKYCyprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/KYC Policy.pdf';
    link.download = 'Privacy KYC Policy Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadDCAprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/TTBS_DIGITAL_CONSENT_REST_API.pdf';
    link.download = 'TTBS_DIGITAL_CONSENT_REST_API';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadVoiceprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/DLT_Voice Registration Process for TM PE-140XXX-Promo Calls V2.pdf';
    link.download = 'DLT_Voice_140XXX_Series_Registeration_Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  downloadSeriesRegprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/DLT_1600XX_Process_steps.pdf';
    link.download = 'DLT_1600XX_Process_steps';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadDltVoiceRegDoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/DLT_Voice_140XXX_Series_Registeration_Process.pdf';
    link.download = 'DLT_Voice_140XXX_Series_Registeration_Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  downloadPETMRegDoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/PE TM Binding.pdf';
    link.download = 'PE_TM_Binding';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  downloadUrlWhitelistingDoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/URL Whitelisting Procedure_Sep24.pdf';
    link.download = 'URL Whitelisting Procedure_Sep24';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadDigitalConsentDoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/Digital_Consent_Acquisition_Communication_Deck.pptx';
    link.download = 'Digital Consent Acquisition - Communication Deck';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadPressReleaseDoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/Press Release_UCC.pdf';
    link.download = 'Press Release_UCC';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  dwldVerificationTemplate() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/TRAI Directives & Steps for Verification and Modification.zip';
    link.download = 'TRAI Directives & Steps for Verification and Modification';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  dwldTRAIPressReleasedoc() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/PR_No.47of2023.pdf';
    link.download = 'PR_No.47of2023';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  get f() {
    return this.commonLoginForm.controls;
  }

  //On click Sing in button 
  SignIn() {
    // if(!this.commonLoginForm.valid){
    // 	alert("Please fill the URN & Password fields");
    // 	return true;
    // }
    var unamev = this.commonLoginForm.get('ID').value;
    var pwdv = this.commonLoginForm.get('password').value;
    if (unamev == "" && pwdv == "") {
      alert("Please fill the URN & Password fields");
    }
    else if (unamev == "") {
      alert("Please enter URN");
    }
    else if (pwdv == "") {
      alert("Please enter password");
    }

    this.submitted = true;
    if (this.commonLoginForm.invalid) {
      return;
    }
    else {

      if (this.f.ID.value.length == 15)
        this.URNorEntityID = "URN"
      else
        this.URNorEntityID = "EntityID"

      console.log(this.f.ID.value == "100000000000026" || this.f.ID.value == "100000000000036" || this.f.ID.value == "100000000000038" || this.f.ID.value == "100000000000045")
      if (this.f.ID.value == "1001469157522312" || this.f.ID.value == "100000000000026" || this.f.ID.value == "100000000000036" || this.f.ID.value == "100000000000038" || this.f.ID.value == "100000000000045")
        this.URNorEntityID = "EntityID"
      var data = {
        "URNorEntityID": this.URNorEntityID,
        //"Entity_Class": this.roleSelected,
        "ID": btoa(this.f.ID.value), //BTOA
        "Entity_Password": btoa(this.f.password.value) //BTOA
      };
      this.loginAPI(data) // functions to validate credentials  
    }
  }

  //Check username, Pwd from mongo
  loginAPI(data) {
    this.ls.loginTMPE(data)
      .subscribe((r) => {
        if (r.message == "Success") {
          
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITYSTATUS, r.entityObj.Entity_Status);

          if (r.entityObj.Entity_Status == 'R') {
            this.errorRefFlag = true
            this.errorRefMsg = "The registration request has got rejected and details have been sent to your registered email ID."
            return
          } else if (r.entityObj.Entity_Status == 'D') {
            this.errorRefFlag = true
            this.errorRefMsg = "The registration request has got auto cancelled, as we have not received the required inputs within the stipulated time."
            return
          }
          else if (this.URNorEntityID == "URN" && (r.entityObj.Entity_ID != '' || r.Kyc_Status == "P") && (atob(r.entityObj.Payment_Flag)) == "true") {   //Edited for Entity-Payment   

            this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG, r.entityObj.Payment_Flag);
            this.readonly = true;
            this.entityStatus = r.entityObj.Entity_Status;
            this.Kyc_Status = r.entityObj.Kyc_Status;
            this.blacklisted = r.entityObj.Entity_BlackList_Status
            this.userName = r.entityObj.Entity_AuthSignName
            this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userName);
            //this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
            this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.entityObj.Entity_ID);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY, r.entityObj.Entity_Cert_Expiry_Dateformat);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_TOKEN, r.entityObj.Entity_Token);// pradnya key based authentication
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN, r.entityObj.Entity_Ref_No);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME, r.entityObj.Entity_AuthSignName);
            //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, r.entityObj.Entity_AuthSignName);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME, r.entityObj.E_Org_Name);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME, r.entityObj.Entity_AuthSignName);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_TYPE, r.entityObj.E_Org_Type);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ADDR, r.entityObj.Entity_Addr);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS, r.entityObj.Entity_Class);
            this.db.set(Constants.SESSSION_STORAGE, Constants.Hash_KYC_Doc, r.entityObj.Hash_KYC_Doc);
            this.db.set(Constants.SESSSION_STORAGE, Constants.Entity_EmailID, atob(r.entityObj.Entity_EmailID));  //ATOB
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO, atob(r.entityObj.Entity_Mobile_No));  //ATOB


            this.entityExpiry = r.entityObj.Entity_Cert_Expiry_Dateformat;
            this.EntityId = r.entityObj.Entity_ID;
            this.Entity_Ref_No = r.entityObj.Entity_Ref_No;
            this.Entity_Name = r.entityObj.Entity_Name;
            this.Entity_User_Name = r.entityObj.Entity_User_Name;
            this.E_Org_Name = r.entityObj.E_Org_Name;
            this.Entity_EmailID = atob(r.entityObj.Entity_EmailID); //ATOB
            this.MobileNumber = atob(r.entityObj.Entity_Mobile_No); //ATOB
            this.errorReg = false;
            this.errorUser = false;
            this.roleSelected = r.entityObj.Entity_Class
            localStorage.setItem('currentUser', "user")
            this.showGenerateOTP = true;
            this.readonly = true;
            this.generateOTP();

          } else if (this.URNorEntityID == "URN" && r.entityObj.Entity_ID != '') {
            this.errorRefFlag = true
            this.errorRefMsg = "You are already approved. Please access you profile with approved ID to proceed further!"
            return
          } /*else if (this.URNorEntityID == "URN" && r.entityObj.Registration_From) {       
				this.errorRefFlag = true
				this.errorRefMsg = "You are already approved. Please access you profile with approved ID to proceed further!"   
				return
			}*/  else {
            this.readonly = true;
            this.entityStatus = r.entityObj.Entity_Status;
            this.Kyc_Status = r.entityObj.Kyc_Status;
            this.blacklisted = r.entityObj.Entity_BlackList_Status
            this.userName = r.entityObj.Entity_AuthSignName
            this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userName);
            //this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
            this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.entityObj.Entity_ID);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY, r.entityObj.Entity_Cert_Expiry_Dateformat);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_TOKEN, r.entityObj.Entity_Token);// pradnya key based authentication
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN, r.entityObj.Entity_Ref_No);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME, r.entityObj.Entity_AuthSignName);
            //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, r.entityObj.Entity_AuthSignName);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME, r.entityObj.E_Org_Name);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME, r.entityObj.Entity_AuthSignName);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_TYPE, r.entityObj.E_Org_Type);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ADDR, r.entityObj.Entity_Addr);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS, r.entityObj.Entity_Class);
            this.db.set(Constants.SESSSION_STORAGE, Constants.Hash_KYC_Doc, r.entityObj.Hash_KYC_Doc);
            this.db.set(Constants.SESSSION_STORAGE, Constants.Entity_EmailID, atob(r.entityObj.Entity_EmailID));
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO, atob(r.entityObj.Entity_Mobile_No));

            this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG, r.entityObj.Payment_Flag);
            this.entityExpiry = r.entityObj.Entity_Cert_Expiry_Dateformat;
            this.EntityId = r.entityObj.Entity_ID;
            this.Entity_Ref_No = r.entityObj.Entity_Ref_No;
            this.Entity_Name = r.entityObj.Entity_Name;
            this.Entity_User_Name = r.entityObj.Entity_User_Name;
            this.E_Org_Name = r.entityObj.E_Org_Name;
            this.Entity_EmailID = atob(r.entityObj.Entity_EmailID);
            this.MobileNumber = atob(r.entityObj.Entity_Mobile_No);
            this.errorReg = false;
            this.errorUser = false;
            this.roleSelected = r.entityObj.Entity_Class
            localStorage.setItem('currentUser', "user")
            this.showGenerateOTP = true;
            this.readonly = true;
            this.generateOTP();

          }
        } else if (r.message == "IDNotFound") {
          this.errorRefFlag = true
          this.errorRefMsg = "ID is not exists in DLT!"
          return
        } else if (r.message == "Blacklisted") {
          this.errorRefFlag = true
          this.errorRefMsg = "Your ID is Blacklisted!"
          return
        } else if(r.message == "Inactive") {
          this.errorRefFlag = true
          this.errorRefMsg = "Your ID is Inactive!"
          return
        } else if (r.message == "Invalid Password") {
          this.errorReg = true;
          this.errorUser = false;
          this.errorRefFlag = false;

        } else if (r.message == "Invalid Entity ID / Unique Reference ID") {
          this.errorReg = false;
          this.errorUser = true;
          this.errorRefFlag = false;

        }
        else {
          this.errorUser = true;
          this.errorReg = false;
          this.errorRefFlag = false;
        }
      });
  }

  // sending the otp to PE and RTM when username exists
  generateOTP() {
    this.OTP_clicked = true;
    let hideMobile = [];
    let mobile = this.MobileNumber || '';
    let splitMobileNum = mobile.split("");
    for (let i = 0; i <= splitMobileNum.length - 1; i++) {
      if (i == 0 || i == 1 || i == 2 || i == 3 || i == 4 || i == 5 || i == 6) {
        hideMobile.push('X');
      } else {
        hideMobile.push(splitMobileNum[i]);

      }
    }
    this.hideMobileNum = hideMobile.toString().replace(/\,/g, "");
    var otp = {
      "mobileNo": btoa(this.MobileNumber),
      "email": btoa(this.Entity_EmailID)
    }
    this.ls.generateOtpEntity(otp)
      .subscribe((r) => {
        if (r.message == "OTP successfully sent.") {
          this.signFlag = false
          this.db.set(Constants.SESSSION_STORAGE, Constants.USERID_OTP, r.userid);
        }
        else {

        }
      })
  }
  isURNCheck: boolean = false;
  focusOutFunction() {
    var data = this.commonLoginForm.get('ID').value;
    let checkval = data.substring(0, 2)
    if (data === undefined || data == "") {
      this.isURNCheck = false;
      return;
    }

    //if(checkval === '10') { 
    if (data.length === 15) {
      this.isURNCheck = false;
    }
    // else if (data.length === 19 || data.length === 8 || data.length === 10 || data.length === 12 || data.length === 16) { 
    else if (data.length > 7) {
      this.isURNCheck = false;
    } else {
      this.isURNCheck = true;
    }

  }

  onSubmit() {

    this.homeRole = false;
    this.loginFlag = false;
    this.errorOtpexpired = false;
    this.errorOtp = false;
    this.InactiveEntity = false;
    this.blacklistedEntity = false;
    this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
    this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
    let data;
    if (this.f.ID.value.length == 15) {
      data =
      {
        "mobileno": btoa(this.MobileNumber),
        "OTP": btoa(this.f.otp.value),
        "Page": "Common-Login-TMPE",
        "Module": "Common-Login",
        "URNorEntityID": "URN",
        "ID": this.Entity_Ref_No
      };

    }
    else {
      data =
      {
        "mobileno": btoa(this.MobileNumber),
        "OTP": btoa(this.f.otp.value),
        "Page": "Common-Login-TMPE",
        "Module": "Common-Login",
        "URNorEntityID": "EntityID",
        "ID": this.EntityId
      }
    }

    console.log("----data--", data);

    this.ls.verifyOtpEntity(data)
      .subscribe((r) => {
        if (r.message == "OTP Successfully Verified") {

          this.es.setpwdexpirydiffdays(r.diff_days, r.entityExpiryDiffDays, r.hasEntityCertExpired)

          // this.db.set(Constants.SESSSION_STORAGE, Constants.PWDEXPBALANCEDAYS,r.diff_days);

          this.db.set(Constants.SESSSION_STORAGE, Constants.URNORENTID, this.URNorEntityID);
          console.log("------------------r.pwdresult-----", r.pwdresult, r.diff_days)

          if (r.pwdresult == "Password will expire") {
            this.$modal.successModal({
              title: 'Entity - Login',
              msg: "Your password will expire in " + r.diff_days + " days. Please change your password to avoid inconvenience"
            });
            //console.log("Your password will expire in " + r.diff_days + " days. Please change your password to avoid inconvenience")
          }

          if (r.pwdresult == "Password Expired") {
            this.$modal.errorModal({
              title: 'Entity - Login',
              msg: "Your password has expired, Please change the password"
            });
            console.log("Your password has expired, Please change the password")
            this.router.navigateByUrl('/change-password')
          }
          else {

            this.OTP_clicked = false
            this.homeRole = true;
            this.loginFlag = true;
            console.log("r.login", r.last_login)
            if (r.last_login) {
              this.db.set(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN, r.last_login);
              this.login1 = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
              console.log("In Constructor   ", this.login1)
            }
            this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
            this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);
            this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY, this.entityExpiry);
            this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userName);

            this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, this.roleSelected);
            //Added for logout
            this.db.set(Constants.SESSSION_STORAGE, Constants.URNORENTID, this.URNorEntityID);

            //this.db.set(Constants.SESSSION_STORAGE, Constants.ACCESS_TKN, r.accessToken);
            //this.db.set(Constants.SESSSION_STORAGE, Constants.REFRESH_TKN, r.refreshToken);t

            if (this.URNorEntityID == "URN") {
              let Flag = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG)
              let payFlag = atob(Flag)//Added for Entity-Payment
              //Added for logout
              this.db.set(Constants.SESSSION_STORAGE, Constants.URN, this.f.ID.value);
               console.log("------payFlag---tmpecommonlogin----", payFlag, this.Kyc_Status)
              this.errorReg = false;
              this.errorUser = false;
              this.errorRefFlag = true;
              if (this.entityStatus == 'A' && payFlag == "false") {
                this.errorRefMsg = "Your Request is processed. Please login with the Entity ID communicated to your registered email ID."
              }
              else if ((this.entityStatus == 'P' || this.Kyc_Status == "P") && payFlag == "true") {
                this.evt.emit({ 'click': 'HEADER_EVENT' });
                this.evt.emit({ 'click': 'HEADER_EVENT_' });
                this.router.navigateByUrl('/tmpe-modify-after-approval', { replaceUrl: true })
              }
              else if (this.entityStatus == 'C') {
                this.errorRefMsg = "Your Entity registration request verification is in progress. You will receive the update on your registered email ID."

              } else if (this.entityStatus == 'M1' || this.entityStatus == 'M2') {
                this.modifyUrl = true
                this.errorRefMsg = "Clarifications/inputs are required. Please click here to provide the inputs."

              } else if (this.entityStatus == 'I') {
                this.ui2Url = true
                this.errorRefMsg = "Registration process is not completed. Please click here to complete the process."

              } else if (this.entityStatus == 'R') {
                this.errorRefMsg = "The registration request has got rejected and details have been sent to your registered email ID."
              }
            } else {
              if (this.entityStatus == 'A' || this.entityStatus == 'C' || this.entityStatus == 'M1' || this.entityStatus == 'M2') {
                this.evt.emit({ 'click': 'HEADER_EVENT' });
                this.evt.emit({ 'click': 'HEADER_EVENT_' });
                this.router.navigateByUrl('/tmpe-modify-after-approval', { replaceUrl: true })
              }

              else if (this.entityStatus == 'R') {
                this.errorRefMsg = "The registration request has got rejected and details have been sent to your registered email ID."
              }
            }


          }
        }
        else if (r.message == "Entity is already loggged in Please perform logout") {
          this.$modal.errorModal({
            title: 'Entity - Login',
            msg: "Entity is already logged in. Please perform log out"
          });
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.f.ID.value);
          this.db.set(Constants.SESSSION_STORAGE, Constants.URNORENTID, this.URNorEntityID);

          this.ls.logOut(this.f.ID.value, this.URNorEntityID)
            .subscribe((r) => {
              console.log("r ", r)
              this.commonLoginForm.reset({ 'ID': '', 'password': '', 'otp': '', 'phoneNumber': '' })
              this.OTP_clicked = false;
              this.readonly = false;
              this.signFlag = true;
              sessionStorage.clear()
              this.router.navigateByUrl('/')
            })
          // this.logErr = true;
          // this.logErrMsg = r.message
        }
        else {
          this.homeRole = false;
          this.loginFlag = false;
          this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
          this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);
          this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY, this.entityExpiry);
          
          if (r.message == "OTP expired") {
            this.errorOtpexpired = true;

          }
          else if (r.message == "OTP not validated") {
            this.errorOtp = true;
          }


          else if (this.entityStatus == "I")
            this.InactiveEntity = true;

          else if (this.blacklisted == true)
            this.blacklistedEntity = true;
        }
      })
  }

  dwldVerificationDocument() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/TRAI_Update_6thSep2023.docx';
    link.download = 'TRAI_Update_6thSep2023';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }


}

